// **** Generated File: Do NOT edit!  **********
// Generated from java class: com.abinitio.webcommons.abweb.dto.product.ProductInfoItem
// using template webcommons/abinitio/build/codegen/src/main/resources/tsTemplates/TSClass.vm

import { KendoObservableObjectProxy } from "abweb/dto/kendo/KendoObservableObjectProxy";
export class ProductInfoItemBase extends KendoObservableObjectProxy {
  /** Do NOT invoke directly, instead use strongly typed createProductInfoItemBase factory method */
  constructor() {
    super();
  }

  // @ts-ignore: noUnusedLocals
  getJavaClass() {
    return "cawadp.ProductInfoItem";
  }
  initFromJson(json, deserializeContext) {
    this.initProductInfoItem(json.name != null ? json.name : null, json.value != null ? json.value : null);
  }
  initProductInfoItem(name, value) {
    this.initKendoObservableObjectProxy();
    this._name = name;
    this._value = value;
  }
  toTSOG(result, serializeContext) {
    const retVal = super.toTSOG(result, serializeContext);
    retVal["name"] = this._name;
    retVal["value"] = this._value;
    return retVal;
  }
  get name() {
    return this._name;
  }
  set name(value) {
    this._name = value;
  }
  get value() {
    return this._value;
  }
  set value(value) {
    this._value = value;
  }
}
//# sourceMappingURL=ProductInfoItemBase.js.map
